<div fxFlex fxLayout="column" fxLayoutGap="1rem">
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span>{{ 'vehicles.vehicles' | translate }}</span>
      <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="primary" (click)="editVehicle()">
        <mat-icon>add</mat-icon>
        {{ 'vehicles.actions.create' | translate }}
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-card appearance="outlined" fxFlex="grow" fxLayout="column">
    <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onChangeTab($event)">
      <mat-tab [label]="'vehicles.enabled' | translate"></mat-tab>
      <mat-tab [label]="'vehicles.disabled' | translate"></mat-tab>
    </mat-tab-group>
    <table mat-table [dataSource]="dataSource" class="main-content" #vehiclesTable>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{ 'vehicles.description' | translate }}</th>
        <td mat-cell *matCellDef="let vehicle">{{ vehicle.description }}</td>
      </ng-container>

      <ng-container matColumnDef="licensePlate">
        <th mat-header-cell *matHeaderCellDef>{{ 'vehicles.licensePlate' | translate }}</th>
        <td mat-cell *matCellDef="let vehicle">{{ vehicle.licensePlate }}</td>
      </ng-container>

      <ng-container matColumnDef="licenseClass">
        <th mat-header-cell *matHeaderCellDef>{{ 'vehicles.licenseClass' | translate }}</th>
        <td mat-cell *matCellDef="let vehicle">{{ vehicle.licenseClass | licenseClass | async }}</td>
      </ng-container>

      <ng-container matColumnDef="department">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.department' | translate }}</th>
        <td mat-cell *matCellDef="let vehicle">
          @if (vehicle.department) {
            <span class="department-color" [style.background-color]="vehicle.department.color"></span>
            {{ vehicle.department.name }}
          } @else {
            <span class="department-missing">&mdash;</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let vehicle" (click)="$event.stopPropagation()" class="actions-column">
          <mat-menu #vehicleActions>
            <button mat-menu-item (click)="editVehicle(vehicle['@id'])">{{ 'vehicles.actions.edit' | translate }}</button>
            @if (vehicle.enabled) {
              <button mat-menu-item *ngxPermissionsOnly="['ROLE_USER']" (click)="deactivateDriver(vehicle)">{{ 'vehicles.actions.deactivate' | translate }}</button>
            }
          </mat-menu>

          <button mat-button [matMenuTriggerFor]="vehicleActions">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let vehicle; columns: tableColumns"
        [routerLink]="['/vehicles', vehicle | objectId]"
        [class]="'linked-row'"
      ></tr>
    </table>
  </mat-card>

  @if (vehiclesTable.dataSource.length == 0) {
    <app-no-result-message></app-no-result-message>
  }

  @if (actionPending$ | async) {
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
